import React, { useState, useEffect } from 'react';
import { Container, Row, Col, Card, Button, Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import './ThemeList.css';
import { BASE_URL_API } from '../environment';

const ThemeList = () => {
  const navigate = useNavigate();
  const [themes, setThemes] = useState([]);
  const [appliedThemeId, setAppliedThemeId] = useState(null); // Placeholder for applied theme ID
  const [showModal, setShowModal] = useState(false);
  const [selectedThemeId, setSelectedThemeId] = useState(null);
  const [startDateTime, setStartDateTime] = useState('');
  const [endDateTime, setEndDateTime] = useState('');
 
// Fetch themes from MongoDB and determine the active theme 
useEffect(() => {
    console.log('useEffect running'); 
    const fetchThemes = async () => {
      try {
        const response = await fetch(`${BASE_URL_API}themes/toget`, {
          method: 'GET',
          headers: { 'Content-Type': 'application/json' },
        });
        if (response.ok) {
          const data = await response.json();
          console.log('Fetched themes data:', data); // Log the fetched data
          setThemes(data);
          const activeResponse = await fetch(`${BASE_URL_API}themes/active`);
          console.log('what this active response is coming ', activeResponse); // Log the active response
          if (activeResponse.ok) {
          const activeTheme = await activeResponse.json();
          setAppliedThemeId(activeTheme?._id || null); // Set applied ID from active theme
        }
        } else {
          console.error('Failed to fetch themes');
        }
      } catch (error) {
        console.error('Error fetching themes:', error);
      }
    };
    
    fetchThemes();
  }, []);

  const handleApply = (themeId) => {
    setSelectedThemeId(themeId);
    setShowModal(true);
  };

  const handleSave = async () => {
    if (!startDateTime || !endDateTime) {
      alert('Please fill in both Start Date/Time and End Date/Time');
      return;
    }
  
    try {
      // Fetch all themes to check for overlaps
      const response = await fetch(`${BASE_URL_API}themes/toget`);
      if (response.ok) {
        const themes = await response.json();
        const startTime = new Date(startDateTime).getTime();
        const endTime = new Date(endDateTime).getTime();
  
        // Check for overlaps with existing themes (excluding the current theme being updated)
        const hasOverlap = themes.some(theme => {
          if (!theme.startDateTime || !theme.endDateTime || theme._id === selectedThemeId) return false;
          const themeStart = new Date(theme.startDateTime).getTime();
          const themeEnd = new Date(theme.endDateTime).getTime();
          return startTime < themeEnd && endTime > themeStart; // Overlap if periods intersect
        });
  
        if (hasOverlap) {
          alert('Cannot schedule: This time range overlaps with an existing theme. Please choose a different time.');
          return;
        }
  
        // Proceed with scheduling if no overlap
        const updateResponse = await fetch(`${BASE_URL_API}themes/putDateTime/${selectedThemeId}`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ startDateTime, endDateTime }),
        });
        if (updateResponse.ok) {
          console.log('Theme scheduled with dates');
          setShowModal(false);
          setStartDateTime('');
          setEndDateTime('');
          // Refresh themes
          const updatedResponse = await fetch(`${BASE_URL_API}themes/toget`);
          if (updatedResponse.ok) {
            const data = await updatedResponse.json();
            setThemes(data);
          }
          const activeResponse = await fetch(`${BASE_URL_API}themes/active`); // API: GET /themes/active - Fetches the current active theme
          if (activeResponse.ok) {
            const activeTheme = await activeResponse.json();
            setAppliedThemeId(activeTheme?._id || null); // Update appliedThemeId immediately
          }
        } else {
          console.error('Failed to schedule theme');
        }
      } else {
        console.error('Failed to fetch themes for overlap check');
      }
    } catch (error) {
      console.error('Error scheduling theme:', error);
    }
  };

  const handleRemove = async (themeId) => {
    try {
      const response = await fetch(`${BASE_URL_API}themes/putDateTime/${themeId}`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ startDateTime: null, endDateTime: null }),
      }); // API: PUT /themes/putDateTime/:id - Removes the theme by setting dates to null
      if (response.ok) {
        console.log('Theme removed from applied status');
        setAppliedThemeId(null); // Clear applied theme ID
        const updatedResponse = await fetch(`${BASE_URL_API}themes/toget`); // API: GET /themes/toget - Refreshes the theme list
        if (updatedResponse.ok) {
          const data = await updatedResponse.json();
          setThemes(data);
        }
      } else {
        console.error('Failed to remove theme');
      }
    } catch (error) {
      console.error('Error removing theme:', error);
    }
  };
  
    const handleClose = () => {
      setShowModal(false);
      setStartDateTime('');
      setEndDateTime('');
    };


  

  const handleEdit = (themeId) => {
    console.log('Editing theme with ID:', themeId); // Log the theme ID being edited
    navigate(`/dashboard/changetheme/${themeId}`); // Edit theme
  };

return (
    <Container fluid className="py-4 theme-list-container">
        <Row className="mb-4">
            <Col>
                <h2 className="theme-list-title">Available Themes</h2>
            </Col>
        </Row>
        <Row className="g-3">
            {themes.length === 0 ? (
                <Col>
                    <p className="text-muted">No themes yet. Create one to get started!</p>
                </Col>
            ) : (
                themes.map((theme) => (
                    <Col key={theme._id} xs={12} sm={6} md={4} lg={3}>
                        <Card
                            className="theme-card"
                            style={{
                                border: 'none',
                                borderRadius: '12px',
                                boxShadow: '0 4px 12px rgba(0, 0, 0, 0.1)',
                                transition: 'transform 0.2s ease',
                                padding: '0',
                                height: '100%',
                                background: '#fff',
                            }}
                            onMouseEnter={(e) => {
                                e.currentTarget.style.transform = 'translateY(-4px)';
                                e.currentTarget.style.boxShadow = '0 6px 16px rgba(0, 0, 0, 0.15)';
                            }}
                            onMouseLeave={(e) => {
                                e.currentTarget.style.transform = 'none';
                                e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.1)';
                            }}
                        >
                            <Card.Body style={{ padding: '16px', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                                <div
                                    style={{
                                        background: theme.colors.ionBackgroundColor,
                                        width: '100%',
                                        padding: '12px 16px',
                                        borderBottom: '1px solid #ddd',
                                        marginBottom: '8px',
                                        borderRadius: '8px 8px 0 0',
                                        border: '1px solid grey',
                                        display: 'flex',
                                        justifyContent: 'space-between',
                                        alignItems: 'center'
                                    }}
                                >
                                    <Card.Title
                                        style={{
                                            fontSize: '1.1rem',
                                            fontWeight: 600,
                                            color: theme.ionTextColor || '#000000',
                                            background: theme.colors.ionBackgroundColor,
                                            margin: '0',
                                        }}
                                    >
                                        {theme.name}
                                    </Card.Title>
                                    {theme._id === appliedThemeId && <div className="applied-badge">Applied</div>}
                                </div>

                                {theme.startDateTime ? (
<>          
    <Card.Text className="date-section">
        <div className="duration-row">
            <span role="img" aria-label="duration">⏳</span> Duration
        </div>
        <div className="date-row">
            <div className="date-item">
                <span className="date-label">From</span>
                <span className="date-value">
                    {new Date(theme.startDateTime).toLocaleDateString('en-US', {
                        day: '2-digit',
                        month: '2-digit',
                        year: 'numeric',
                    })}
                </span>
            </div>
            <div className="date-item">
                <span className="date-label">To</span>
                <span className="date-value">
                    {theme.endDateTime
                        ? new Date(theme.endDateTime).toLocaleDateString('en-US', {
                                day: '2-digit',
                                month: '2-digit',
                                year: 'numeric',
                            })
                        : new Date(theme.startDateTime).toLocaleDateString('en-US', {
                                day: '2-digit',
                                month: '2-digit',
                                year: 'numeric',
                            })}
                </span>
            </div>
        </div>
    </Card.Text>
    {/* {theme._id === appliedThemeId && <div className="applied-badge">Approved</div>} */}
</>
) : (
<Card.Text className="placeholder-text">
    <span>Not Applied Yet</span>
    <span className="placeholder-note">Click 'Apply' to set dates and activate this theme!</span>
</Card.Text>
)}

                    <div className="button-row">
                    <Button
                        variant="outline-primary"
                        className="theme-btn"
                        onClick={() => handleEdit(theme._id)}
                    >
                        Edit
                    </Button>
                    {(appliedThemeId !== theme._id || (!theme.startDateTime && !theme.endDateTime)) && (
                    <Button
                      variant="success"
                      className="theme-btn"
                      onClick={() => handleApply(theme._id)}
                    >
                      Apply
                    </Button>
                  )}
                    {theme.startDateTime && theme.endDateTime && appliedThemeId === theme._id && (
                        <Button
                            variant="danger"
                            className="theme-btn1"
                            onClick={() => handleRemove(theme._id)} // Placeholder
                        >
                            Remove
                        </Button>
                    )}
                    </div>
                            </Card.Body>
                        </Card>
                    </Col>
                ))
            )}
        </Row>
        <Button
            variant="success"
            className="fab"
            onClick={() => navigate('/dashboard/changetheme')}
        >
            +
        </Button>

 <Modal show={showModal} onHide={handleClose}>
    <Modal.Header closeButton>
      <Modal.Title className="modal-title">Schedule Theme</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <div className="modal-input-group">
        <label htmlFor="startDateTime" className="modal-label">Start Date/Time</label>
        <input
          type="datetime-local"
          className="modal-input"
          id="startDateTime"
          value={startDateTime}
          max={endDateTime} // Prevent selecting a date/time later than endDateTime
          onChange={(e) => setStartDateTime(e.target.value)}
        />
      </div>
      <div className="modal-input-group">
        <label htmlFor="endDateTime" className="modal-label">End Date/Time</label>
        <input
          type="datetime-local"
          className="modal-input"
          id="endDateTime"
          value={endDateTime}
          min={startDateTime} // Prevent selecting a date/time earlier than startDateTime
          onChange={(e) => setEndDateTime(e.target.value)}
        />
      </div>
    </Modal.Body>
    <Modal.Footer className="modal-footer">
      <Button variant="secondary" className="modal-btn" onClick={handleClose}>
        Close
      </Button>
      <Button variant="success" className="modal-btn" onClick={handleSave}>
        Schedule
      </Button>
    </Modal.Footer>
  </Modal>  
    </Container>
);
};

export default ThemeList;